import { useContextState } from "../../../../../../hooks/theme" 

const useStyles = ({margin}:{margin?:boolean}) => {
    const { colors } = useContextState()

    return {
        container: {
            marginBottom: margin? '20px':'0px',
            color: colors.color13,
            padding: '16px 24px',
        },
        textBig: {
            fontSize: '60px',
            color: 'c_green.main',
            lineHeight: '1',
            margin: '0',
        },
        textSmall: {
            fontSize: '40px',
            lineHeight: '1',
            margin: '0',
            paddingBottom: '5px'
        },
        title: {
            textAlign: 'end',
            fontSize: '13px',
            fontWeight: '500'
        },
        display: {
            display: 'flex',
            alignItems: 'flex-end',
        }
    }
}

export { useStyles }